<template>
  <div class="message-queue-create">
    <el-button class="mb-x2" type="default" @click="changeTab('queue-list')"
      ><i class="mdi mdi-arrow-left"></i>戻る</el-button
    >
    <!-- 種別-->
    <div class="input-container">
      <div class="label">種別</div>
      <el-select v-model="type" @change="onChangeType" :disabled="isDisabledInput" placeholder="選択してください">
        <el-option v-for="(type, index) in types" :value="type.value" :label="type.label" :key="index"></el-option>
      </el-select>
      <div class="description" v-if="typeText">宛先: {{ typeText }}</div>
    </div>
    <!-- 対象メッセージ-->
    <div class="input-container">
      <div class="label">対象メッセージ</div>
      <el-select
        v-model="messageId"
        @change="onMessageChange"
        :disabled="isDisabledInput || isAllMessageDisabled"
        placeholder="対象メッセージ"
      >
        <el-option :value="null" label="全てのメッセージ" key=""></el-option>
        <el-option
          v-for="(message, index) in messages"
          :value="message.id"
          :label="message.name"
          :key="index"
        ></el-option>
      </el-select>
    </div>
    <div class="mt-x1 mb-x2" v-if="!isSendCountLoading">
      <div class="description mt-0">配信対象数: {{ sendCount }}</div>
      <div class="description mt-0" v-if="isLimitSendCount">残り配信可能数: {{ remainMonthlyDmCount }}</div>
      <div class="text-danger" v-if="isRemainEmpty">残り配信可能数がありません。</div>
      <div class="text-danger" v-else-if="isSendCountEmpty">配信対象となる当選者が存在しません。</div>
      <div class="text-danger" v-else-if="isSendCountOver">配信対象数が残り配信可能数を超えています。</div>
    </div>
    <!-- テンプレート-->
    <div class="input-container">
      <div class="label">テンプレート</div>
      <div class="template-manage">
        <el-select
          class="mr-x2"
          v-model="template"
          @change="onChangeTemplate"
          :disabled="isDisabledInput"
          placeholder="テンプレートを呼び出す場合、選択してください"
        >
          <el-option
            v-for="(messageTemplate, index) in messageTemplates"
            :value="messageTemplate.id"
            :label="messageTemplate.name"
            :key="index"
          ></el-option> </el-select
        ><a href="/settings/group#templates" target="_blank"
          ><i class="mdi mdi-open-in-new mr-x1"></i>テンプレート管理</a
        >
      </div>
    </div>
    <!-- メッセージ内容-->
    <div class="input-container">
      <div class="label">
        メッセージ内容
        <div class="sub">{{ formatNumber(bodyLength) }} / {{ formatNumber(maxLength) }}</div>
      </div>
      <editable
        class="body-textarea"
        v-model="body"
        :highlights="highlights"
        :placeholder="'内容入力'"
        :class="{ success: $v.body.required && !$v.body.$invalid && body.trim() }"
        :disabled="isDisabledInput"
      ></editable>
      <div class="input-invalid-text" v-if="(!$v.body.required && $v.body.$error) || bodyLength === 0">
        メッセージ内容を入力してください。
      </div>
      <div class="input-invalid-text" v-if="bodyLength > maxLength">文字数は4,000文字以下にしてください。</div>
      <div class="mt-x1" v-if="!messageId && hasUnsetSerialCodeMessage && hasSerialCodeInMessageBody">
        <Message type="danger"
          >シリアルコード未登録の自動配信メッセージがあるため、このままではメッセージを配信できません。<br />配信開始までに
          [シリアルコードの管理] から追加してください。</Message
        >
      </div>
      <div class="mt-x1" v-if="!messageId && hasSetSerialCodeMessage && !hasSerialCodeInMessageBody">
        <Message type="warning"
          >シリアルコードが登録されているメッセージがあります。<br />配信する場合は、変数(_serial_code_)をメッセージ内容に入力してください。</Message
        >
      </div>
      <div class="mt-x1" v-if="messageId && !isSerialCodeConfigured && hasSerialCodeInMessageBody">
        <Message type="danger"
          >シリアルコードが未登録のため、このままではメッセージを配信できません。<br />配信開始までに
          [シリアルコードの管理] から追加してください。</Message
        >
      </div>
      <div class="mt-x1" v-if="messageId && isSerialCodeConfigured && !hasSerialCodeInMessageBody">
        <Message type="warning"
          >登録されているシリアルコードがあります。<br />配信する場合は、変数(_serial_code_)をメッセージ内容に入力してください。</Message
        >
      </div>
    </div>
    <!-- メッセージのメディアアップロード-->
    <div
      class="input-container mb-x4"
      v-loading="isLoadMedia"
      element-loading-text="画像・動画をアップロードしています。 しばらくお待ちください。"
    >
      <div v-if="!isDisabledInput">
        <label class="el-button el-button--default"
          ><i class="mdi mdi-image"></i><span v-if="!media">画像/動画を追加</span
          ><span v-if="media">画像/動画を変更</span>
          <input
            type="file"
            style="display: none"
            @change="handleFileChange($event)"
            accept="video/mp4,image/jpeg,image/png,image/pjpeg,image/gif"
            ref="mediaInput"
          /> </label
        ><span class="pl-x2">アップロード可能最大サイズ: 画像5MB 動画25MB</span>
      </div>
      <div class="mt-x2 media-preview" v-if="media">
        <i class="mdi mdi-close" v-if="!isDisabledInput" @click="removeMedia"></i>
        <div class="media-name">{{ media.mediaOriginName }}</div>
        <img class="direct-media mt-x1" v-if="media && isImage" :src="media.mediaUrl" />
        <video class="direct-media mt-x2" v-if="media && !isImage" :src="media.mediaUrl" controls="true"></video>
      </div>
    </div>
    <div class="input-container">
      <MessageConvert></MessageConvert>
    </div>
    <!-- メッセージ配信開始日-->
    <div class="input-container">
      <div class="label">メッセージ配信開始日</div>
      <el-date-picker
        v-model="startDate"
        ref="startDate"
        type="date"
        value-format="yyyy-MM-dd"
        prefix-icon="mdi mdi-calendar-today"
        placeholder="開始日"
        :picker-options="startDateOption"
        :editable="false"
        :disabled="isDisabledInput"
      ></el-date-picker>
      <div class="input-invalid-text" v-if="isDateInput">開始日を入力してください。</div>
    </div>
    <!-- メッセージ配信時間-->
    <div class="input-container">
      <div class="label">メッセージ配信時間</div>
      <el-time-select
        class="mr-x1"
        v-model="startTime"
        ref="startTime"
        prefix-icon="mdi mdi-clock"
        placeholder="開始時間"
        :picker-options="startTimeOption"
        :editable="false"
        :disabled="isDisabledInput"
      ></el-time-select
      >~
      <el-time-select
        class="ml-x1"
        v-model="endTime"
        ref="endTime"
        prefix-icon="mdi mdi-clock"
        placeholder="終了時間"
        :picker-options="endTimeOption"
        :editable="false"
        :disabled="isDisabledInput"
      ></el-time-select>
      <div class="input-invalid-text" v-if="!isDateInput && isStartTimeInput">開始時間を入力してください。</div>
      <div class="input-invalid-text" v-if="!isDateInput && isEndTimeInput">終了時間を入力してください。</div>
      <div class="input-invalid-text" v-else-if="isTimeOver">終了時間は、開始時間より後に設定してください。</div>
      <div class="input-invalid-text" v-else-if="isDatetimeOver">
        開始日時は、現時刻より5分をこえるよう指定してください。
      </div>
      <div class="description">終了時間までに配信完了しなかった場合、翌日の開始時間に配信を再開します。</div>
    </div>
    <div class="input-container">
      <div class="label">
        1日の最大配信数(0=制限なし)
        <el-tooltip class="ml-x1" placement="top">
          <template v-slot:content>
            <span
              v-html="
                'X公式APIで送信できるDMは、1アカウントにつき24時間で最大100件です。<br>この配信のみで100件を使い切りたくない場合は、1日の最大配信数を設定してください。<br>配信対象者数が1日の最大配信数より多い場合、上限到達後に配信を翌日に繰り越します。<br>配信再開は、翌日のメッセージ配信時間です。'
              "
            ></span>
          </template>
          <template v-slot:default><i class="mdi mdi-help-circle ml-x1"></i></template>
        </el-tooltip>
      </div>
      <el-input-number
        controls-position="right"
        :min="0"
        v-model="sendLimitPerDay"
        :max="maxSendLimitPerDay"
        size="small"
      ></el-input-number>

      <div v-if="isExistQueue" class="message message-warning mt-x1 pl-x2 pr-x2">
        同一のXアカウントで1日に複数のメッセージ配信が予約されており、配信時間が重複する可能性があります。
        <br />
        配信上限を超えると配信が停止するため、超えそうな場合は配信数やメッセージ配信時間を調整してください。
        <br />
        詳しくは<a
          href="https://help-atelu.comnico.jp/0f4d7649-12aa-435a-abb6-868c2027000e#0f4d7649-12aa-435a-abb6-868c2027000e"
          target="_blank"
          rel="noopener noreferrer"
          >こちら</a
        >をご確認ください。
      </div>
      <div v-else-if="isUnlimitedOrLimit100" class="message message-warning mt-x1 pl-x2 pr-x2">
        1日のDM配信上限（1日100件）に設定されています。配信対象者が100件を超える場合、翌日のメッセージ配信時間に配信が再開されます。
        <br />
        また、この設定の配信期間中は「リマインド」や「シリアルコード未使用のリマインド」を含む追加のDM配信はできません。
      </div>
      <div v-else-if="isLimitOneHourToTwoHoursMessage" class="message message-warning mt-x1 pl-x2 pr-x2">
        {{ limitOneHourToTwoHoursMessage }}
        <br />
        DM配信上限（24時間で100件）に設定したい場合メッセージ配信時間を2時間半以上に設定してください。
      </div>
    </div>

    <div class="dialog-footer" v-if="isEdit">
      <el-button type="default" :disabled="disabledSubmit || isDisabledInput" @click="saveDraft"
        ><i class="mdi mdi-content-save"></i>下書き保存</el-button
      >
      <el-button
        type="primary"
        :disabled="disabledSubmit || isDisabledInput || isRemainEmpty || isSendCountEmpty || isSendCountOver"
        @click="saveScheduled"
        ><i class="mdi mdi-content-save"></i>一括配信スケジュールを更新</el-button
      >
    </div>
    <div class="dialog-footer" v-else>
      <el-button type="default" :disabled="disabledSubmit || isDisabledInput" @click="createDraft"
        ><i class="mdi mdi-content-save"></i>下書き保存</el-button
      >
      <el-button
        type="primary"
        :disabled="disabledSubmit || isDisabledInput || isRemainEmpty || isSendCountEmpty || isSendCountOver"
        @click="createScheduled"
        ><i class="mdi mdi-email"></i>一括配信スケジュールを新規作成</el-button
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use 'sass:math';
@use '@/client/assets/scss/variables.scss' as *;

.input-container {
  margin: 0 0 ($spacing-unit * 2);
}

.description {
  margin-top: $spacing-unit;
  color: $sub-text-color;
}

.label {
  position: relative;
  margin: 0 0 $spacing-unit;
  font-size: $font-size;
  font-weight: 700;

  .sub {
    position: absolute;
    top: 0;
    right: 0;
    color: $sub-text-color;
  }
}

.el-select {
  width: 40%;
}

.template-manage {
  div {
    display: inline-block;
  }
}

.body-textarea {
  min-height: 180px;
  max-height: 800px;
}

.media-preview {
  position: relative;
  display: inline-block;
  padding: math.div($spacing-unit, 2) $spacing-unit;
  border: 1px solid $border-color;
  border-radius: $round;

  .media-name {
    padding-right: $spacing-unit * 3;
  }

  .mdi {
    position: absolute;
    top: math.div($spacing-unit, 2);
    right: math.div($spacing-unit, 2);
    cursor: pointer;
  }
}

.direct-media {
  max-width: 100%;
  max-height: $spacing-unit * 32;
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment'
import { mapActions, mapState } from 'pinia'
import twitterText from 'twitter-text'
import { defineComponent } from 'vue'
import { required } from 'vuelidate/lib/validators'

import Editable from '@/client/components/_atoms/editable'
import Message from '@/client/components/_atoms/Message.vue'
import MessageConvert from '@/client/components/_atoms/message_convert'
import api from '@/client/core/api'
import TwitterUpload from '@/client/core/twitter_upload'
import { formatNumber } from '@/client/filters/filters'
import { useSystemStore } from '@/client/store/useSystemStore'
import { useTwitterInstantwinMessageStore } from '@/client/store/useTwitterInstantwinMessageStore'
import { useTwitterInstantwinQueueStore } from '@/client/store/useTwitterInstantwinQueueStore'

export default defineComponent({
  props: {
    isChangeWithoutSubmit: Boolean
  },
  data() {
    return {
      type: 0,
      sentAccountFilterType: 0,
      answeredAccountFilterType: 1,
      body: '',
      startDate: null,
      startDateOption: {
        disabledDate(time: any) {
          return moment(time.getTime()).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')
        }
      },
      sendLimitPerDay: 0,
      startTime: null,
      startTimeOption: {
        start: '00:00',
        step: '00:30',
        end: '23:30'
      },
      endTime: null,
      endTimeOption: {
        start: '00:00',
        step: '00:30',
        end: '23:30'
      },
      isDisabledInput: false,
      isSubmit: false,
      media: null,
      isLoadMedia: false,
      uploadTimer: null,
      oldTemplate: '',
      template: '',
      messageTemplates: [],
      messageId: null,
      remainMonthlyDmCount: 0,
      remainMonthlyDmCountDefault: 0,
      maxMonthlyDmCount: 0,
      sendCount: 0,
      isSendCountLoading: false,
      rawData: {},
      isSerialCodeConfigured: false,
      isFirstEdit: true
    }
  },
  components: {
    Editable,
    MessageConvert,
    Message
  },
  beforeDestroy() {
    if (this.uploadTimer) {
      clearInterval(this.uploadTimer)
    }

    this.reset()
  },
  async mounted() {
    this.getMessageTemplates()

    if (this.queueId) {
      await this.getMessageQueueById()
    }

    this.getSendCount()

    this.getSerialCodeSetting()

    this.rawData = this.getMessageData()

    if (!this.queueId) {
      this.isFirstEdit = true
    }
  },

  watch: {
    isFormChanged(value: boolean) {
      this.$emit('update:isChangeWithoutSubmit', value)
    },

    startDate(value: string) {
      if (value) {
        this.updateRemainMonthlyDmCount()

        if (!this.isFirstEdit) {
          const params: { accountId: number; actionDatetime: string; queueId?: number; campaignType?: string } = {
            accountId: this.campaign.account.id,
            actionDatetime: this.messageData.actionDatetime
          }

          if (this.isEdit) {
            params.queueId = this.messageQueueId
            params.campaignType = 'instantwin'
          }

          this.fetchCheckExistQueues(params)
        }
      }
    },

    startTime(value: string) {
      if (value && !this.isFirstEdit) {
        const params: { accountId: number; actionDatetime: string; queueId?: number; campaignType?: string } = {
          accountId: this.campaign.account.id,
          actionDatetime: this.messageData.actionDatetime
        }

        if (this.isEdit) {
          params.queueId = this.messageQueueId
          params.campaignType = 'instantwin'
        }

        this.fetchCheckExistQueues(params)
      }
    },

    isStartDateTimeInEdit(value: boolean) {
      if (value && this.isFirstEdit) {
        this.isFirstEdit = false

        const params: { accountId: number; actionDatetime: string; queueId?: number; campaignType?: string } = {
          accountId: this.campaign.account.id,
          actionDatetime: this.messageData.actionDatetime
        }

        if (this.isEdit) {
          params.queueId = this.messageQueueId
          params.campaignType = 'instantwin'
        }

        this.fetchCheckExistQueues(params)
      }
    },

    maxSendLimitPerDay(value: number) {
      if (value < this.sendLimitPerDay) this.sendLimitPerDay = 0
    }
  },

  computed: {
    ...mapState(useSystemStore, {
      currentGroup: state => state.currentGroup
    }),

    ...mapState(useTwitterInstantwinMessageStore, {
      campaign: state => state.campaign,
      messages: state => state.messages.filter(message => message.messageType === 'win')
    }),

    ...mapState(useTwitterInstantwinQueueStore, {
      queueId: state => state.queueMessages.queueId,
      isExistQueue: state => state.isExistQueue
    }),

    types() {
      const types = [
        {
          label: '当選通知',
          value: 0,
          text: '一度も当選メッセージを配信していない未回答の当選者全員'
        },
        {
          label: 'リマインド',
          value: 2,
          text: '当選通知を配信したことのある、未回答の当選者全員'
        },
        {
          label: 'シリアルコード未使用のリマインド',
          value: 3,
          text: 'シリアルコードが未使用の当選者全員(使用済みシリアルコードをシリアルコードの管理にインポートできます。)'
        }
      ]

      if (this.messageId === null) {
        types.push({
          label: '配信失敗した応募者への再配信',
          value: 4,
          text: '配信に失敗した応募者'
        })
      }

      return types
    },

    /**
     * 新規作成か編集かのチェック
     */
    isEdit() {
      return this.queueId > 0
    },

    isStartDateTimeInEdit() {
      return this.startDate && this.startTime
    },

    /**
     * 種別が配信失敗した応募者への再配信の場合は、全てのメッセージにしてdisabledにする
     */
    isAllMessageDisabled() {
      return this.type === 4
    },

    /**
     * ヘルプテキスト取得
     */
    typeText() {
      let text = null

      this.types.forEach(type => {
        if (type.value === this.type) text = type.text
      })

      return text
    },

    /**
     * ハイライト定義データ
     */
    highlights() {
      return [{ type: 'info', keywords: ['_account_name_', '_screen_name_', '_account_id_', '_serial_code_'] }]
    },

    /**
     * メッセージ内容の文字数取得
     */
    bodyLength() {
      if (!this.body) {
        return 0
      }

      return twitterText.parseTweet(this.body).weightedLength
    },

    /**
     * メッセージ最大長
     */
    maxLength() {
      return 4000
    },

    hasSerialCodeInMessageBody() {
      return /_serial_code_/.test(this.body)
    },

    hasUnsetSerialCodeMessage() {
      return this.messages.some(v => v.countSerialCode === 0)
    },

    hasSetSerialCodeMessage() {
      return this.messages.some(v => v.countSerialCode > 0)
    },

    disabledSubmit() {
      if (
        !this.startDate ||
        !this.startTime ||
        this.body === '' ||
        this.bodyLength > this.maxLength ||
        this.body.trim().length === 0 ||
        this.isLoadMedia
      ) {
        return true
      }

      if (this.isDateInput || this.isStartTimeInput || this.isEndTimeInput || this.isDatetimeOver || this.isTimeOver) {
        return true
      }

      return false
    },

    isImage() {
      const reg = /[.](jpeg|png|gif|pjpeg|jpg)$/i
      return reg.test(this.media.mediaUrl)
    },

    isSendCountEmpty() {
      return this.sendCount === 0
    },

    isLimitSendCount() {
      return this.remainMonthlyDmCount !== null
    },

    isRemainEmpty() {
      return this.remainMonthlyDmCount === 0
    },

    isSendCountOver() {
      if (this.remainMonthlyDmCount === null) return false
      return this.sendCount > this.remainMonthlyDmCount
    },

    isDateInput() {
      return !this.startDate
    },

    isStartTimeInput() {
      return !this.startTime
    },

    isEndTimeInput() {
      return this.startTime && !this.endTime
    },

    isDatetimeOver() {
      const datetime = moment(`${this.startDate} ${this.startTime}`, 'YYYY-MM-DD HH:mm')
      const limitDatetime = moment().add(5, 'minute')

      return datetime.unix() < limitDatetime.unix()
    },

    isTimeOver() {
      return this.startTime && this.startTime >= this.endTime
    },

    messageData() {
      return {
        messageId: this.messageId,
        campaignId: this.campaign.id,
        type: this.type,
        body: this.body,
        actionDatetime: this.getActionDatetime(),
        endTime: this.endTime,
        sendLimitPerDay: this.sendLimitPerDay,
        sentAccountFilterType: this.sentAccountFilterType,
        answeredAccountFilterType: this.answeredAccountFilterType,
        media: this.media
      }
    },

    isFormChanged() {
      return JSON.stringify(this.messageData) !== JSON.stringify(this.rawData)
    },

    maxSendLimitPerDay() {
      if (this.startTime && this.endTime) {
        const startTime = moment(this.startTime, 'HH:mm')
        const endTime = moment(this.endTime, 'HH:mm')

        const differenceInMinutes = endTime.diff(startTime, 'minutes')

        // 30分と比較して
        if (differenceInMinutes <= 30) {
          return 20
        }

        // 1時間と比較
        if (differenceInMinutes <= 60) {
          return 40
        }

        // 1.5時間と比較して
        if (differenceInMinutes <= 90) {
          return 60
        }

        // 2時間と比較してください
        if (differenceInMinutes <= 120) {
          return 80
        }
      }

      return 100
    },

    isUnlimitedOrLimit100() {
      return [0, 100].includes(this.sendLimitPerDay)
    },

    isLimitOneHourToTwoHoursMessage() {
      if ([20, 40, 60, 80].includes(this.maxSendLimitPerDay)) {
        return this.sendLimitPerDay === this.maxSendLimitPerDay
      }

      return false
    },

    limitOneHourToTwoHoursMessage() {
      let time = ''

      if (this.maxSendLimitPerDay === 20) {
        time = '30分間'
      }

      if (this.maxSendLimitPerDay === 40) {
        time = '1時間'
      }

      if (this.maxSendLimitPerDay === 60) {
        time = '1時間半'
      }

      if (this.maxSendLimitPerDay === 80) {
        time = '2時間'
      }

      return `リスク回避のため、ATELUでは${time}で最大${this.maxSendLimitPerDay}件のペースで送信する制限を設けてます。`
    }
  },
  methods: {
    formatNumber,

    ...mapActions(useTwitterInstantwinQueueStore, ['fetchCheckExistQueues']),

    reset() {
      this.type = null
      this.sentAccountFilterType = 0
      this.answeredAccountFilterType = 1
      this.body = ''
      this.startDate = null
      this.startTime = null
      this.endTime = null
      this.sendLimitPerDay = 0
      this.isDisabledInput = false
      this.isSubmit = false
      this.$v.body.$reset()
      this.oldTemplate = ''
      this.template = ''
      this.messageTemplates = []
      this.messageId = null
      this.isLoadMedia = false
    },

    /**
     * Get message queue by id
     */
    async getMessageQueueById() {
      const queue = await api.get(`/twitter_instantwin_queues/${this.queueId}`)

      if (!queue || !queue.data) {
        return
      }

      const { status, type, body, actionDatetime, media, messageId, endTime, sendLimitPerDay } = queue.data
      const isDisabledStatus = status === 'sent' || status === 'sending' || status === 'paused'

      this.isDisabledInput = isDisabledStatus
      this.type = type
      this.body = body
      this.messageId = messageId
      this.sendLimitPerDay = sendLimitPerDay
      this.startDate = moment(actionDatetime).format('YYYY-MM-DD')
      this.startTime = moment(actionDatetime).format('HH:mm')
      this.endTime = endTime ? moment(endTime, 'HH:mm:ss').format('HH:mm') : null

      this.media = media ? Object.assign({}, media) : null

      if (!isDisabledStatus) {
        this.onChangeType()
      }
    },

    /**
     * Get list message template
     */
    async getMessageTemplates() {
      const params = {
        groupId: this.currentGroup.id,
        sortBy: 'name'
      }

      const messageTemplates = await api.get('/message_templates', {
        params
      })

      if (messageTemplates && messageTemplates.data && messageTemplates.data.templates) {
        this.messageTemplates = messageTemplates.data.templates
      }
    },

    /**
     * 種別の変更
     */
    onChangeType() {
      switch (this.type) {
        case 0:
          this.sentAccountFilterType = 0
          this.answeredAccountFilterType = 1
          break
        case 1:
          this.sentAccountFilterType = 1
          this.answeredAccountFilterType = 1
          break
        case 2:
          this.sentAccountFilterType = 2
          this.answeredAccountFilterType = 1
          break
      }

      this.getSendCount()
    },

    /**
     * メッセージの変更
     */
    onMessageChange() {
      this.getSendCount()
      this.getSerialCodeSetting()
    },

    /**
     * テンプレート
     * @param {number} templateId
     */
    onChangeTemplate(templateId: number) {
      const currentTemplate = this.messageTemplates.find(template => template.id === templateId)
      const body = currentTemplate.body

      if (!this.body) {
        this.body = body
        this.oldTemplate = templateId
        return
      }

      const confirmChange = confirm('メッセージがすでに入力されています。テンプレートの内容に置き換えてよろしいですか?')

      if (!confirmChange) {
        this.template = this.oldTemplate
        return
      }

      this.oldTemplate = templateId
      this.body = body
    },

    /**
     * 配信対象数と残り配信可能数の取得処理
     * @returns {void}
     */
    async getSendCount() {
      this.sendCount = 0
      this.remainMonthlyDmCount = 0
      this.maxMonthlyDmCount = 0

      const params = {
        type: this.type,
        campaignId: this.campaign.id,
        messageId: this.messageId
      }

      this.isSendCountLoading = true

      const result = await api.get(`/twitter_instantwin_queues/send_counts`, { params })

      this.isSendCountLoading = false

      if (!result || !result.data) {
        return
      }

      const { sendCount, remainMonthlyDmCount, maxMonthlyDmCount } = result.data

      this.sendCount = sendCount
      this.remainMonthlyDmCount = remainMonthlyDmCount
      this.remainMonthlyDmCountDefault = remainMonthlyDmCount
      this.maxMonthlyDmCount = maxMonthlyDmCount
      this.updateRemainMonthlyDmCount()
    },

    /**
     * 残り配信可能数を更新
     */
    updateRemainMonthlyDmCount() {
      if (this.maxMonthlyDmCount === 0) return

      const today = moment()
      const isAfter = moment(this.startDate, 'YYYY-MM').isAfter(today, 'month')

      this.remainMonthlyDmCount = isAfter ? this.maxMonthlyDmCount : this.remainMonthlyDmCountDefault
    },

    /**
     * シリアルコードの設定有無の取得
     */
    getSerialCodeSetting() {
      if (this.messageId) {
        const selectMessage = this.messages.find(v => v.id === this.messageId)

        this.isSerialCodeConfigured = selectMessage?.countSerialCode > 0
      }
    },

    /**
     * Set params
     * @param {string} type
     * @returns {any} params
     */
    getParams(type: string) {
      return { ...this.messageData, status: type }
    },

    /**
     * 下書き保存（既存）
     */
    saveDraft() {
      if (this.isSubmit) return

      const params = this.getParams('draft')
      this.putButton(params)
    },

    /**
     * スケジュール保存（既存）
     */
    saveScheduled() {
      if (this.isSubmit) return

      const params = this.getParams('scheduled')
      this.putButton(params)
    },

    /**
     * 下書き保存（新規）
     */
    createDraft() {
      if (this.isSubmit) return

      const params = this.getParams('draft')
      this.postButton(params)
    },

    /**
     * スケジュール保存（新規）
     */
    createScheduled() {
      if (this.isSubmit) return

      const params = this.getParams('scheduled')
      this.postButton(params)
    },

    /**
     * メッセージ配信開始日時の取得
     */
    getActionDatetime() {
      return moment.tz(`${this.startDate} ${this.startTime}`, 'YYYY-MM-DD HH:mm', 'Asia/Tokyo').format()
    },

    /**
     * メッセージキューの更新
     * @param {Object} params 配信データ
     */
    async putButton(params: any) {
      this.isSubmit = true

      const response = await api.put(`/twitter_instantwin_queues/${this.queueId}`, params)

      setTimeout(() => {
        this.isSubmit = false
      }, 2000)

      if (response.data) {
        this.$notify({
          title: 'メッセージを保存しました。',
          customClass: 'success',
          duration: 5000
        })

        this.$emit('update:isChangeWithoutSubmit', false)
        this.$nextTick(() => this.changeTab('queue-list'))
        return
      }

      if (response.error && response.error.type === 'NOT_EXISTS') {
        const title = '対象のメッセージが見つかりません。'
        const message = '恐れ入りますが、時間をおいて再度お試しください。'
        this.showError(title, message)
        return
      }

      if (response.error && response.error.type === 'MESSAGE_QUEUE_COUNT_OVER') {
        const title = '同じ時間にスケジュールされている一括配信があります。'
        const message = '30分以上間隔を空けるようにしてください。'
        this.showError(title, message)
        return
      }

      const title = 'メッセージの保存に失敗しました。'
      const message = '恐れ入りますが、時間をおいて再度お試しください。'
      this.showError(title, message)
    },

    /**
     * メッセージキューの新規作成
     * @param {Object} params 配信データ
     */
    async postButton(params: any) {
      this.isSubmit = true

      const response = await api.post(`/twitter_instantwin_queues`, params)

      setTimeout(() => {
        this.isSubmit = false
      }, 2000)

      if (response.data) {
        this.$notify({
          title: 'メッセージを作成しました。',
          customClass: 'success',
          duration: 5000
        })

        this.$emit('update:isChangeWithoutSubmit', false)
        this.$nextTick(() => {
          this.changeTab('queue-list')
        })
        return
      }

      if (response.error && response.error.type === 'DUPLICATE') {
        const title = '同じ時間にスケジュールされている一括配信があります。'
        const message = '30分以上間隔を空けるようにしてください。'
        this.showError(title, message)
        return
      }

      const title = 'メッセージの作成に失敗しました。'
      const message = '恐れ入りますが、時間をおいて再度お試しください。'
      this.showError(title, message)
    },

    /**
     * メンションのメディアファイル削除
     */
    removeMedia() {
      this.media = null
    },

    /**
     * エラーを表示
     * @param {string} title
     * @param {string} message
     */
    showError(title: string, message: string) {
      this.$notify({
        title,
        message,
        customClass: 'danger',
        dangerouslyUseHTMLString: true,
        duration: 5000
      })
    },

    /**
     * ファイルのメンションを変更
     */
    async handleFileChange(e: any) {
      if (!e.target.files || !e.target.files[0]) {
        return
      }

      const file = e.target.files[0]
      this.$refs.mediaInput.value = null

      const validFormat = ['video/mp4', 'image/jpeg', 'image/png', 'image/gif', 'image/pjpeg', 'image/gif']

      // メディアをチェック
      const checkValidMedia = await TwitterUpload.checkValidMedia(file, validFormat)

      if (checkValidMedia.error) {
        const error = checkValidMedia.error

        let title = ''
        let message = ''

        switch (error) {
          case 'INVALID_MEDIA':
            title = 'Please upload valid format!'
            message = validFormat.join(', ')
            break
          case 'MAX_SIZE_VIDEO':
            title = '25MB以上のビデオを利用することはできません。 サイズを調整してからアップロードしてください。'
            break
          case 'MAX_SIZE_IMAGE':
            title = '5MB以上の画像を利用することはできません。サイズを調整してからアップロードしてください。'
            break
          case 'INVALID_DIMENSION':
            title = '画像・動画アップロードに失敗しました。'
            message =
              '詳しくは<a target="_blank" href="https://help-atelu.comnico.jp/available-image-and-video">こちら</a>をご確認ください。'
            break
        }

        this.showError(title, message)

        return
      }

      this.isLoadMedia = true

      const formData = new FormData()
      formData.append('file', file)

      if (file.type.includes('video')) {
        const mediaCheck = await TwitterUpload.checkMedia(formData)

        if (!mediaCheck) {
          const title = '画像・動画アップロードに失敗しました。'
          const message =
            '詳しくは<a target="_blank" href="https://help-atelu.comnico.jp/available-image-and-video">こちら</a>をご確認ください。'

          this.showError(title, message)
          this.isLoadMedia = false

          return
        }
      }

      formData.append('accountId', this.campaign.account.id)
      formData.append('forDM', 'true')

      const result = await TwitterUpload.uploadMedia(formData)

      // アップロードプログレスを取得
      const progressResult = await this.getUploadProgress(result.data.filename)

      if (progressResult) {
        const media = {
          mediaOriginName: file.name,
          mediaUrl: progressResult.mediaUrl,
          twMediaId: progressResult.mediaId,
          expiresAfterSecs: progressResult.expiresAfterSecs
        }

        this.media = this.media ? Object.assign(this.media, media) : media
      }

      this.isLoadMedia = false
    },

    /**
     * アップロードプログレスを取得
     * @param {string} filename
     */
    getUploadProgress(filename: string): Promise<any> {
      return new Promise(resolve => {
        this.uploadTimer = setInterval(async () => {
          const progress = await api.get(`/twitter_uploads/progresses?filename=${filename}`)
          if (progress.data) {
            clearInterval(this.uploadTimer)
            resolve(progress.data)
          }

          if (progress.error) {
            if (progress.error.statusCode === 400) {
              const title = '画像・動画アップロードに失敗しました。'
              const message =
                '詳しくは<a target="_blank" href="https://help-atelu.comnico.jp/available-image-and-video">こちら</a>をご確認ください。'

              this.showError(title, message)
            } else {
              const title = '画像・動画アップロードに失敗しました。'
              const message = '恐れ入りますが、時間をおいて再度お試しください。'

              this.showError(title, message)
            }

            clearInterval(this.uploadTimer)
            resolve(null)
          }
        }, 3000)
      })
    },

    /**
     * Change screen
     * @param {string} tab
     */
    changeTab(tab: string) {
      if (!this.isChangeWithoutSubmit) {
        return this.$emit('change_tab', tab)
      }

      const confirm = window.confirm('編集内容が保存されていません。ダイアログを閉じてよろしいですか?')

      if (!confirm) {
        return
      }

      this.$emit('update:isChangeWithoutSubmit', false)
      this.$emit('change_tab', tab)
    },

    /**
     * メッセージのデータを取得
     */
    getMessageData() {
      return {
        messageId: this.messageId,
        campaignId: this.campaign.id,
        type: this.type,
        body: this.body,
        actionDatetime: this.getActionDatetime(),
        endTime: this.endTime,
        sendLimitPerDay: this.sendLimitPerDay,
        sentAccountFilterType: this.sentAccountFilterType,
        answeredAccountFilterType: this.answeredAccountFilterType,
        media: this.media
      }
    }
  },
  validations: {
    body: {
      required
    }
  }
})
</script>
